import { useState } from "react";
import styles from "./leasesignsuccess.module.css";
import Loader from "../../../components/Loader";
import { Helmet } from "react-helmet";

const LeaseSignSuccess = () => {
    const [loading, setLoading] = useState(false);

    return (<>
        {loading && <Loader />}
        <Helmet title="Offer" />

        LeaseSignSuccess
    </>)
}

export default LeaseSignSuccess;